<main id="app-div">
  <ts-telespot-shell></ts-telespot-shell>
</main>
